import { FoodSupplementManagement } from '@/components/food-supplement/FoodSupplementManagement';

export const FoodSupplementPage = () => {
  return <FoodSupplementManagement />;
};
